var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECEFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_19101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_19101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0058 24C14.9047 24 13.8681 23.7917 12.8958 23.375C11.9236 22.9583 11.0729 22.3854 10.3438 21.6562C9.61458 20.9271 9.04167 20.0767 8.625 19.105C8.20833 18.1333 8 17.0951 8 15.9904C8 14.8857 8.20833 13.8507 8.625 12.8854C9.04167 11.9201 9.61458 11.0729 10.3438 10.3438C11.0729 9.61458 11.9233 9.04167 12.895 8.625C13.8667 8.20833 14.9049 8 16.0096 8C17.1143 8 18.1493 8.20833 19.1146 8.625C20.0799 9.04167 20.9271 9.61458 21.6562 10.3438C22.3854 11.0729 22.9583 11.9217 23.375 12.89C23.7917 13.8585 24 14.8932 24 15.9942C24 17.0953 23.7917 18.1319 23.375 19.1042C22.9583 20.0764 22.3854 20.9271 21.6562 21.6562C20.9271 22.3854 20.0783 22.9583 19.11 23.375C18.1415 23.7917 17.1068 24 16.0058 24ZM16 22.5C17.8056 22.5 19.3403 21.8693 20.6042 20.6079C21.8681 19.3465 22.5 17.8071 22.5 15.9896C22.5 15.1215 22.3369 14.2903 22.0108 13.496C21.6846 12.7017 21.2157 12.0017 20.6042 11.3958L16 16V9.5C14.1944 9.5 12.6597 10.1319 11.3958 11.3958C10.1319 12.6597 9.5 14.1944 9.5 16C9.5 17.8056 10.1319 19.3403 11.3958 20.6042C12.6597 21.8681 14.1944 22.5 16 22.5Z",
    fill: "#3F25AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutIcon);
export default __webpack_public_path__ + "static/media/payout-icon.84b0c8529f18915a93aae1b54bde1920.svg";
export { ForwardRef as ReactComponent };